import moment from 'moment';

import {
  type ModelUserChatMessageDto,
  UserMessageType,
} from '@app/api/UserChat';

import type { AiChatMessageViewModel } from '@pages/AiAgents/types';

moment.locale('ru');

export const mapMessagesToViewModel = (
  messages: ModelUserChatMessageDto[],
  currentUserId: number | null | undefined
): AiChatMessageViewModel[] =>
  messages.map((message) => {
    const isOwn = currentUserId != null && message.Sender?.Id === currentUserId;
    const isSystem = message.Type === UserMessageType.System;

    const createdAtMoment = moment(message.CreatedAt);
    const createdAtFormatted = createdAtMoment.isValid()
      ? createdAtMoment.format('DD.MM.YYYY HH:mm')
      : message.CreatedAt;

    return {
      id: message.Id,
      text: message.Text ?? '',
      createdAt: message.CreatedAt,
      createdAtFormatted,
      isOwn,
      isSystem,
      senderName:
        message.Sender?.Name ??
        (isSystem ? 'Системное сообщение' : 'Пользователь'),
    };
  });
